/* eslint-disable radix */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
import classnames from "classnames";
import Element from "component/design-system/react-scroll/components/Element";
import Link from "next/link";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { Component } from "react";
import { renderHTML } from "../../util/DomHelper";
import { encodeImageName } from "../../util/helper/encodeImageName";
import { isNumberNaN } from "../../util/helper/isNumberNaN";
import { scrollTo } from "../../util/scroll-helper";
import VizSensor from "../design-system/VizSensor";
import LandingPageBanner from "./LandingPageBanner";
import styles from "./landingPage.module.scss";

const propTypes = {
  data: PropTypes.object.isRequired,
};

const defaultProps = {
  data: {
    headers: {},
    d: [],
    manufacturers: [],
  },
};

class LandingPageAllBrands extends Component {
  onClickLetter(letter: any) {
    const element = `anchor_brand_${letter}`;

    scrollTo(element, {
      duration: 500,
      delay: 100,
      smooth: true,
      offset: -110,
    });
  }

  handleClickBrand(brand: any) {
    this.props.router.push(brand.url);
  }

  renderAZBrandImage(brand: any) {
    return (
      <Link href={`/search?ph=${brand}`}>

        <VizSensor forceSSR>

          <img
            src={
              `${process.env.NEXT_PUBLIC_ROOT_URL
              }/images/manufacturers/${
                encodeImageName(brand)
              }-glowing_2160627.png`
            }
          />
        </VizSensor>
      </Link>
    );
  }

  render() {
    const { data } = this.props;

    const alphabet = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

    const brandMap = {};
    alphabet.forEach((letter) => {
      const manufacturers = data.manufacturers.filter(
        (m: any) => m.charAt(0).toUpperCase() == letter
          || (letter == "#" && !isNumberNaN(parseInt(m.charAt(0)))),
      );

      if (manufacturers.length > 0) {
        Object.assign(brandMap, {
          [letter]: manufacturers,
        });
      }
    });

    return (
      <div className={styles.brand_container}>

        <h1>

          <strong>{data.headers.h1}</strong>
        </h1>

        <LandingPageBanner
          bannerImages={{ desktopImage: `${process.env.NEXT_PUBLIC_ROOT_URL}/images/${data.imageUrl}` }}
          className="hidden-xs img-responsive width-100pct"
          alt={data.headers.h1}
        />

        <div className={`${styles.section} ${styles.section_odd}`}>

          <div
            className="m-t-20 m-b-20"
            dangerouslySetInnerHTML={renderHTML(data.d[0])}
          />

          <h2 className="m-t-40">

            <strong>{data.headers.h2S1}</strong>
          </h2>

          <div className={styles.letters}>
            {alphabet.map((letter, index) => (
              <div
                key={index}
                className={classnames({
                  [styles.disabled]:
                    data.manufacturers.findIndex(
                      (m: any) => m.charAt(0).toUpperCase() == letter
                        || (letter == "#"
                          && !isNumberNaN(parseInt(m.charAt(0)))),
                    ) == -1,
                })}
                onClick={this.onClickLetter.bind(this, letter)}
              >
                {letter.toUpperCase()}
              </div>
            ))}
          </div>

          <hr className="m-t-30" style={{ borderColor: "#d7d7d7" }} />

          <h2 className="m-t-40">

            <strong>{data.headers.h2S2}</strong>
          </h2>

          <div className={`row ${styles.row}`}>
            {data.topManufacturers
              && data.topManufacturers.map((m: any, index: number) => (
                <div className="col-sm-6 col-md-4 col-lg-3" key={index}>
                  <div
                    className={`panel ${styles.panel} panel-default`}
                    onClick={this.handleClickBrand.bind(this, m)}
                  >

                    <div className={`panel-heading ${styles.panel_heading}`}>{m.name}</div>

                    <div className={`panel-body ${styles.panel_body}`}>

                      <VizSensor forceSSR minHeight={107}>

                        <img
                          style={{ minHeight: 107 }}
                          src={
                      `${process.env.NEXT_PUBLIC_ROOT_URL
                      }/images/manufacturers/${
                        encodeImageName(m.name)
                      }-glowing_2160627.png`
                          }
                        />
                      </VizSensor>

                    </div>
                  </div>
                </div>
              ))}
          </div>

          <div dangerouslySetInnerHTML={renderHTML(data.d[1])} />
        </div>

        <div className={`${styles.section} ${styles.section_odd}`}>

          <h2 className="m-b-30">

            <strong>{data.headers.h2S3}</strong>
          </h2>

          {brandMap
            && Object.keys(brandMap).map((letter, index) => (
              <VizSensor forceSSR key={index}>

                <div key={index} className={styles.az_content}>

                  <Element name={`anchor_brand_${letter}`} />

                  <h2>

                    <strong>{letter}</strong>
                  </h2>

                  <div className={styles.az_boxes}>

                    {brandMap[letter].map((m: any, index2: any) => (
                      <div key={`${index}_${index2}`} className={`media ${styles.media}`}>

                        <div className={`hidden-xs media-left ${styles.media_left}`}>
                          {this.renderAZBrandImage(m)}
                        </div>

                        <div className={`media-body ${styles.media_body}`}>

                          <div className="visible-xs">

                            <div className="text-center m-t-10 m-b-10">
                              {this.renderAZBrandImage(m)}
                            </div>
                          </div>

                          <div
                            className="p-10"
                            dangerouslySetInnerHTML={renderHTML(
                              data.d[3].replace(
                                new RegExp("{BRAND_NAME}", "g"),
                                m,
                              ),
                            )}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </VizSensor>
            ))}
        </div>
      </div>
    );
  }
}

LandingPageAllBrands.propTypes = propTypes;

LandingPageAllBrands.defaultProps = defaultProps;

const LandingPageAllBrandsWithRouter = (props: any) => {
  const router = useRouter();
  return (
    <LandingPageAllBrands
      {...props}
      router={router}
    />
  );
};

export default LandingPageAllBrandsWithRouter;
